import { useState } from "react";
import { energySourceService } from "@/services/energy-source/energySourceService";
import { useEnergySourceActions } from "./useEnergySourceActions";

type DialogType = "delete";

interface ConfirmationAction {
    type: DialogType;
    energySourceId: string;
    energySourceName: string;
}

export const useConfirmationDialog = (onSuccess: () => void) => {
    const [isOpen, setIsOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState<ConfirmationAction | null>(null);
    const { handleDelete, isLoading } = useEnergySourceActions();

    const openDialog = (action: ConfirmationAction) => {
        setConfirmAction(action);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setIsOpen(false);
        setConfirmAction(null);
    };

    const handleConfirm = async () => {
        if (!confirmAction) return;

        try {
            if (confirmAction.type === "delete") {
                await handleDelete(confirmAction.energySourceId);
                onSuccess();
            }
            closeDialog();
        } catch (error) {
            console.error("Error performing action:", error);
        }
    };

    return {
        isOpen,
        confirmAction,
        isLoading,
        openDialog,
        closeDialog,
        handleConfirm,
    };
}; 